
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"9","viewBox":"0 0 56 72","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.248 69.405c-22.19 0-25.66-14.65-25.661-21.005 0-6.354 1.89-11.745 8.084-19.635 4.236-5.396 2.059-12.017 5.661-19.144 4.752-9.403 18.49-9.506 22.99 0 4.307 9.099.217 13.59 4.663 19.144 7.703 9.62 9.437 14.352 9.437 19.635 0 5.283-2.982 21.005-25.174 21.005z","stroke":"currentColor","stroke-width":"4.18","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"28.004","cy":"48.942","r":"10.884","stroke":"currentColor","stroke-width":"4.18"}})])
          )
        }
      }
    